import * as React from 'react';
import type { Trip } from 'contracts/tracking-v2/trips';
import { cn } from 'lib/utils';

import { getInvoiceInfo } from './utils';

type Props = React.ComponentProps<'div'> & {
  invoice: Trip['invoices'][number];
};

export const InvoiceQuickInfo = ({ className, invoice, ...props }: Props) => {
  const info = getInvoiceInfo(invoice);

  return (
    <div className={cn('bg-gray-100 p-6 rounded-sm grid grid-cols-3 gap-10 xl:flex', className)} {...props}>
      <Info label={'Data Emissão'}>{info.emissionDate}</Info>
      <Info label={'Prazo'}>{info.deadline}</Info>
      <Info label={'Valor'}>{info.value}</Info>
      <Info label={'Origem'}>{info.origin}</Info>
      <Info label={'Destino'}>{info.destination}</Info>
      <Info label={'Centro'}>{info.companyTradeName}</Info>
    </div>
  );
};

const Info = ({
                label,
                children,
              }: React.ComponentProps<'div'> & { label: string }) => {
  return (
    <div className={'flex flex-col gap-1 text-gray-600'}>
      <span className={'text-sm font-GilroySemibold'}>{label}</span>
      <span className={'text-xs font-sans'}>{children}</span>
    </div>
  );
};
